import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Framework',
    href: '#framework'
  }, {
    name: 'Problems We Fix',
    href: '#problems'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Results',
    href: '#results'
  }, {
    name: 'Guarantee',
    href: '#guarantee'
  }, {
    name: 'Packages',
    href: '#packages'
  }, {
    name: 'FAQ',
    href: '#faq'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-navy/95 backdrop-blur-md shadow-lg py-1' : 'bg-transparent py-2'}`} data-id="element-184">
        <div className="container-custom flex items-center justify-between" data-id="element-185">
          <a href="#" className="flex-shrink-0 z-50" data-id="element-186">
            <img src="https://images.squarespace-cdn.com/content/v1/68dc0e53776b445a6a757253/a9936dc6-91ee-4e79-bb13-a7129d009d85/FSG-logo-white%2B%281%29.png" alt="FleetScale Group" className="h-16 md:h-20 w-auto" data-id="element-187" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center space-x-8" data-id="element-188">
            <ul className="flex space-x-6" data-id="element-189">
              {navLinks.map(link => <li key={link.name} data-id="element-190">
                  <a href={link.href} className="text-white/80 hover:text-white text-sm font-medium transition-colors" data-id="element-191">
                    {link.name}
                  </a>
                </li>)}
            </ul>
            <div className="flex items-center space-x-5 border-l border-white/20 pl-6" data-id="element-192">
              <a href="tel:4405840093" className="flex items-center text-white/90 hover:text-white text-sm font-medium group" data-id="element-193">
                <Phone className="w-4 h-4 mr-2 text-amber group-hover:text-white transition-colors" data-id="element-194" />
                (440) 584-0093
              </a>
              <a href="#contact" className="btn-primary py-2.5 px-5 text-xs" data-id="element-195">
                Book Free Consultation
              </a>
            </div>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden text-white z-50 p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-196">
            {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-197" /> : <Menu className="w-6 h-6" data-id="element-198" />}
          </button>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-199">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="fixed inset-0 z-40 bg-navy pt-24 px-6 pb-6 flex flex-col lg:hidden overflow-y-auto" data-id="element-200">
            <ul className="flex flex-col space-y-6 mb-8" data-id="element-201">
              {navLinks.map(link => <li key={link.name} data-id="element-202">
                  <a href={link.href} className="text-white/90 text-2xl font-heading font-semibold block" onClick={() => setMobileMenuOpen(false)} data-id="element-203">
                    {link.name}
                  </a>
                </li>)}
            </ul>
            <div className="mt-auto pt-8 border-t border-white/10 flex flex-col space-y-4" data-id="element-204">
              <a href="tel:4405840093" className="flex items-center justify-center text-white text-lg font-medium py-3 bg-white/5 rounded" data-id="element-205">
                <Phone className="w-5 h-5 mr-3 text-amber" data-id="element-206" />
                (440) 584-0093
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>

      {/* Mobile Sticky Bottom CTA */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-navy border-t border-white/10 p-3 flex gap-3 shadow-[0_-4px_20px_rgba(0,0,0,0.3)]" data-id="element-207">
        <a href="tel:4405840093" className="flex-1 flex items-center justify-center bg-white/10 text-white font-semibold py-3 rounded text-sm" data-id="element-208">
          <Phone className="w-4 h-4 mr-2" data-id="element-209" />
          Call
        </a>
        <a href="#contact" className="flex-[2] btn-primary rounded text-sm" data-id="element-210">
          Book Consultation
        </a>
      </div>
    </>;
}